var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ratio_40"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('DetailContent',{attrs:{"landscape_id":_vm.landscape_id}}),_c('RightSidebar')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }